import { render, staticRenderFns } from "./PrescriptionDetail.vue?vue&type=template&id=74a15e17"
import script from "./PrescriptionDetail.vue?vue&type=script&lang=js"
export * from "./PrescriptionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports